import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "col-md-6" }
const _hoisted_2 = { class: "card scenario-card shadow-sm" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-10" }
const _hoisted_5 = { class: "fw-bold text-secondary" }
const _hoisted_6 = { class: "overflow-hidden" }
const _hoisted_7 = {
  key: 0,
  class: "text-primary"
}
const _hoisted_8 = {
  key: 1,
  class: "text-primary"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "card-content",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router.push({name:'rubric.show',params:{id:_ctx.props.rubric.id}})))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.rubric.name), 1),
            _createElementVNode("div", _hoisted_6, [
              (_ctx.rubric.creator !== null)
                ? (_openBlock(), _createElementBlock("small", _hoisted_7, [
                    _cache[1] || (_cache[1] = _createTextVNode("Created by ")),
                    _createElementVNode("em", null, _toDisplayString(_ctx.rubric.creator.name), 1),
                    _cache[2] || (_cache[2] = _createTextVNode(" on ")),
                    _createElementVNode("em", null, _toDisplayString(_ctx.moment(_ctx.rubric.created_at).format('MM/DD/YY')), 1)
                  ]))
                : (_openBlock(), _createElementBlock("small", _hoisted_8, [
                    _cache[3] || (_cache[3] = _createTextVNode("Created on ")),
                    _createElementVNode("em", null, _toDisplayString(_ctx.moment(_ctx.rubric.created_at).format('MM/DD/YY')), 1)
                  ]))
            ])
          ]),
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "col-md-2 d-flex flex-column justify-content-center" }, [
            _createElementVNode("h3", { class: "text-center" }, [
              _createElementVNode("i", { class: "fas fa-arrow-circle-right text-primary" })
            ])
          ], -1))
        ])
      ])
    ])
  ]))
}